import React from 'react';
import processDesktop from '../assets/mypictorprocess.png';
import processMobile from '../assets/mypictorprocess-mobile.png';
import searchDesktop from '../assets/mypictorsearch.png';
import searchMobile from '../assets/mypictorsearch-mobile.png';

export default function BenefitsSection() {
  return (
    <section className="benefits-section">
      <div className="benefits-container">
        <h2 className="benefits-title">Goodbye, lost photos.<br />Hello, lasting memories.</h2>
        
        <div className="benefits-grid">
          <div className="benefit-item">
            <div className="benefit-image-wrapper">
              <img 
                src={processDesktop}
                srcSet={`${processMobile} 768w, ${processDesktop} 1920w`}
                sizes="(max-width: 768px) 100vw, 100%"
                alt="AI processing" 
                className="benefit-image"
              />
            </div>
            <h3 className="benefit-title">AI-powered organization</h3>
            <p className="benefit-text">
              MyPictor automatically organizes your photos using AI. No manual tagging required—just search and find.
            </p>
          </div>

          <div className="benefit-item">
            <div className="benefit-image-wrapper">
              <img 
                src={searchDesktop}
                srcSet={`${searchMobile} 768w, ${searchDesktop} 1920w`}
                sizes="(max-width: 768px) 100vw, 100%"
                alt="AI search" 
                className="benefit-image"
              />
            </div>
            <h3 className="benefit-title">Find any photo instantly</h3>
            <p className="benefit-text">
              Search by people, places, objects, or events. Find that one photo you need in seconds, not hours.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}

